import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import {
	Form,
	Table,
	Button,
	Input,
	Modal,
	Popconfirm,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	parseTime,
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'mode':'',
			'list':[],
			'showDialog':false,
			'pageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
			
			'rules':{
				'true_name':[
					{
						required: true,
						message: '请输入用户姓名',
					},
				],
				'user_name':[
					{
						required: true,
						message: '请输入手机号',
					},
					{
						pattern: /^1\d\d\d{8}$/,
						message: '请输入正确的手机号',
					},
				],
				'address':[
					{
						required: true,
						message: '请输入详细地址',
					},
				],
				'password_add':[
					{
						required: true,
						message: '请输入密码',
					},
				],
				'password_edit':[
				],
				'password1':[
					{
						validator: (rule,value)=>{
							let password = this.mainForm.getFieldValue('password');
							if(password && value != password)
								return Promise.reject(new Error('两次密码输入不一致'));
							else 
								return Promise.resolve();
						},
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		this.getList();
		document.title = '员工账号 - ' + CommonValue.get('site_name');
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('user','index');
		let param = {
			'page':page,
			'page_size':pageSize,
		};
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info']['total'],
						'pageSize':pageSize,
					},
				});
			});
	}
	
	add()
	{
		this.setState({
			'mode':'add',
			'showDialog':true,
		},()=>{
			this.mainForm.resetFields();
		});
	}
	
	show(index)
	{
		let info = JSON.parse(JSON.stringify(this.state.list[index]));
		info.password = '';
		info.password1 = '';
		
		this.setState({
			'mode':'edit',
			'showDialog':true,
		},()=>{
			this.mainForm.setFieldsValue(info);
		});
	}
	
	delete(index)
	{
		let info = this.state.list[index];
		let url = pcUrl('user','delete');
		let param = {
			'user_id':info['user_id'],
		};
		httpPost(url,param)
			.then(()=>{
				message('用户删除成功','success');
				this.getList(this.state.pageInfo.current);
			});
	}

	submit()
	{
		this.mainForm.validateFields()
			.then(info=>{
				let url = pcUrl('user','save');
				let param = info;
				httpPost(url,param)
					.then(()=>{
						if(!info['user_id'])
							message('账号新增成功','success');
						else
							message('账号编辑成功','success');
						
						this.setState({
							'showDialog':false,
						});
						this.getList(this.state.pageInfo.current);
					});
			})
			.catch(()=>{
				this.focusError(1);
			});
	}
	
	render()
	{
		return (
			<div>
				<div className="user-panel">
					<div className="captain">
						<div class="float-right">
							<a href="javascript:;" className="text-blue" onClick={()=>this.add()}>新增账号</a>
						</div>
						<h3>子账号管理</h3>
					</div>
					<div className="panel-body">
						<Table pagination={{...this.state.pageInfo,'onChange':(page)=>this.getList(page)}} dataSource={this.state.list}>
							<Column title="手机号" dataIndex="user_name" />
							<Column title="姓名" dataIndex="true_name" />
							<Column title="状态" dataIndex="user_status" render={(text,row,index)=>+row['user_status'] ? (
								<span>正常</span>
							):(
								<span className="text-red">审核中</span>
							)} />
							<Column title="添加时间" width={200} dataIndex="add_time" render={(text,row,index)=>parseTime(row.add_time)} />
							<Column title="操作" width={120} key="operate" render={(text,row,index)=>(
								<>
									<a href="javascript:;" className="text-blue" onClick={()=>this.show(index)}>编辑</a>
									&nbsp;&nbsp;&nbsp;
									<Popconfirm
										title="确认删除该记录吗?"
										onConfirm={()=>this.delete(index)}
										onCancel={()=>{}}
										>
										<a href="javascript:;" className="text-gray">删除</a>
									</Popconfirm>
								</>
							)} />
						</Table>
					</div>
				</div>
				
				<Modal
					title={(this.state.mode == 'add' ? '新增':'编辑') + "账号"}
					width={500}
					visible={this.state.showDialog}
					onOk={()=>this.submit()}
					onCancel={()=>this.setState({'showDialog':false})}
					>
					<Form
						labelCol={{ span:5 }}
						wrapperCol={{ span:18 }}
						ref={e=>this.mainForm = e}>
						<Form.Item hidden name="user_id"></Form.Item>
						<Form.Item label="用户姓名" name="true_name" rules={this.state.rules['true_name']}>
							<Input />
						</Form.Item>
						<Form.Item label="手机号" name="user_name" rules={this.state.rules['user_name']}>
							<Input />
						</Form.Item>
						<Form.Item label="密码" name="password" rules={this.state.rules['password_'+this.state.mode]}>
							<Input.Password />
						</Form.Item>
						<Form.Item label="确认密码" name="password1" rules={this.state.rules['password1']}>
							<Input.Password />
						</Form.Item>
					</Form>
				</Modal>
			</div>
		);
	}
}


